<template>
    <div class="Field__Component">
        <div><slot>{{value}}</slot></div>
    </div>
</template>

<script>
export default {
    name: 'FieldStandard',
    props: ['value'],
};
</script>

<style scoped>

</style>
